// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 7H2V16H22V7ZM6 13V10H8V13H6Z"}}]};

const ComponentInputFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-input-filled',
    ref,
    icon: element,
  },
));

ComponentInputFilledIcon.displayName = 'ComponentInputFilledIcon';

export default ComponentInputFilledIcon;
